import type { ModalComponentProps } from '@components/modals/constants';

import { ADDON_ONBOARDINGS } from '../registry';

/**
 * Registry entry point for add-on onboarding.
 *
 * GlobalModalManager renders this inside a MUI <Dialog>, which supplies the
 * portal, backdrop, and centered Paper. The SteppedModal shell the flow is built
 * on is only the modal *content* (header / scrolling body / footer), not a modal
 * in its own right — so it MUST be rendered through this registry path to get the
 * Dialog chrome. (Rendering the flow directly in the tree drops it inline.)
 *
 * `AddOnOnboardingHost` decides which onboarding is due and opens this modal with
 * the entry's id; here we look the entry up and render it, wiring the Dialog's
 * close to the flow's `onDone` (finish or dismiss).
 */
const AddOnOnboardingModal: React.FC<ModalComponentProps> = ({ closeModal, modalProps }) => {
  const onboardingId = modalProps?.onboardingId as string | undefined;
  const entry = ADDON_ONBOARDINGS.find(e => e.id === onboardingId);

  if (!entry) return null;

  return <>{entry.render({ onDone: closeModal })}</>;
};

export default AddOnOnboardingModal;
